export const calculateEventCompletionPercentage = (event) => {
    if (!event) return 0;
    
    const criteria = [
      { check: () => !!event.name, weight: 5 },
      { check: () => !!event.description && event.description.length > 10, weight: 10 },
      { check: () => !!event.type, weight: 5 },
      { check: () => !!event.manifestoID, weight: 5 },
      
      { check: () => !!event.schedule?.startDate, weight: 5 },
      { check: () => !!event.schedule?.startTime, weight: 5 },
      { check: () => !!event.schedule?.endDate, weight: 5 },
      { check: () => !!event.schedule?.endTime, weight: 5 },
      
      { check: () => Array.isArray(event.location) && event.location.length > 0, weight: 15 },
      
      { check: () => Array.isArray(event.members) && event.members.length > 0, weight: 15 },
      
      { check: () => Array.isArray(event.schedules) && event.schedules.length > 0, weight: 15 },
      { 
        check: () => {
          if (!Array.isArray(event.schedules) || event.schedules.length === 0) return false;
          
          const subEventsWithCompleteData = event.schedules.filter(subEvent => 
            subEvent.name && 
            Array.isArray(subEvent.speakers) && 
            subEvent.speakers.length > 0 &&
            Array.isArray(subEvent.logistics) && 
            subEvent.logistics.length > 0 &&
            subEvent.budgetaryAllocation > 0
          );
          
          return subEventsWithCompleteData.length > 0;
        }, 
        weight: 10 
      },
    ];
    
    let score = 0;
    for (const criterion of criteria) {
      if (criterion.check()) {
        score += criterion.weight;
      }
    }
    
    return Math.round(score);
  };